<script lang="ts" setup>
import { v4 as uuid } from 'uuid'
import type { HomePageConfig } from '../../configs/types'
import ModuleCard from './ModuleCard.vue'

const props = defineProps<{
  module: any
  config: HomePageConfig
  cardClass?: string
  headerClass?: string
  gotoBook: (id: string, firstChapterId?: string) => void
  gotoCollection: (id: string) => void
}>()

function handleSeeAll() {
  props.gotoCollection(props.module.id)
}
</script>

<template>
  <ModuleCard
    :title-text="module.showName"
    :action-text-value="config.texts.seeAll"
    :card-class="cardClass"
    :header-class="headerClass"
    @action="handleSeeAll"
  >
    <div class="mt-12px grid grid-cols-3 gap-x-10px gap-y-15px">
      <div v-for="item in module.resourceList.records.slice(0, 6)" :key="item.id" @click="gotoBook(item.id, item.firstChapter?.id)">
        <BizBookCover
          :id="uuid()"
          :src="item.contentCoverUrl || ''"
          :extra="{
            module_name: module.showName,
            module_id: module.id,
            module_type: module.columnType,
            author: item.authorInfo.author,
            ...item,
          }"
          class="rounded-10px"
        />
        <p class="mt-7px text-12px font-medium lh-17px text-n-text-1 line-clamp-2">
          {{ item.contentName }}
        </p>
      </div>
    </div>
  </ModuleCard>
</template>
